// O que está ligado no servidor (20/10/2026): GET /api/recursos, perguntado
// UMA vez por carregamento e dividido entre as chaves do app (circulo/chave.ts,
// mentor-livro/chave.ts). Se falhar, vale {} — tudo desligado.

export type Recursos = { circulo?: boolean; mentorLivro?: boolean };

export const recursos: Promise<Recursos> = typeof window === 'undefined'
  ? Promise.resolve({})
  : fetch('/api/recursos', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : {}))
      .then((j) => (j && typeof j === 'object' ? j : {}))
      .catch(() => ({}));
